import type { CardDef } from "./types";

export const CARD_CATALOG: Record<string, CardDef> = {};

export function loadCardCatalog(cards: CardDef[]): void {
  for (const key of Object.keys(CARD_CATALOG)) delete CARD_CATALOG[key];
  for (const card of cards) CARD_CATALOG[card.id] = card;
}


export function resolveDeck(cardIds: string[]): CardDef[] {
  return cardIds
    .map((id) => CARD_CATALOG[id])
    .filter((c): c is CardDef => c != null);
}


export function getCard(id: string): CardDef {
  if (CARD_CATALOG[id]) return CARD_CATALOG[id];
  if (id.endsWith("_plus")) {
    const base = CARD_CATALOG[id.slice(0, -"_plus".length)];
    if (base) {
      const upgraded = upgradeCard(base);
      CARD_CATALOG[id] = upgraded;
      return upgraded;
    }
  }
  throw new Error(`Unknown card id: ${id}`);
}

export function cardsByClass(classId: string): string[] {
  return Object.values(CARD_CATALOG)
    .filter((c) => c.classId === classId && !c.id.endsWith("_plus"))
    .map((c) => c.id);
}

export function commonCards(): string[] {
  return Object.values(CARD_CATALOG)
    .filter((c) => c.classId == null && !c.id.endsWith("_plus"))
    .map((c) => c.id);
}

function upgradeCard(base: CardDef): CardDef {
  const upgradeVariant = (v: typeof base.hope): typeof base.hope => ({
    cost: v.cost,
    description: `${v.description} (улучшенная)`,
    effects: v.effects.map((e) => {
      if (e.type === "damage" || e.type === "heal") {
        return {
          ...e,
          base: e.base + 2,
          statScale: e.statScale ? { ...e.statScale, mult: e.statScale.mult + 0.5 } : e.statScale,
        };
      }
      if (e.type === "armorBuff") {
        return { ...e, base: e.base + 2 };
      }
      if (e.type === "applyStatus") {
        return { ...e, ttl: e.ttl != null ? e.ttl + 1 : e.ttl };
      }
      return e;
    }),
  });
  return {
    ...base,
    id: `${base.id}_plus`,
    name: `${base.name}+`,
    hope: upgradeVariant(base.hope),
    fear: upgradeVariant(base.fear),
  };
}
